import Hero from './Home/Hero';
import Features from './Home/Features';
import FeatureGrid from './Home/FeatureGrid';
import InsightsSection from './Home/InsightsSection';
import FAQSection from "./Home/FAQSection";
import TestimonialSection from "./Home/TestimonialSection";

function Home() {
    return (
        <>
            <Hero />
            <Features />
            <FeatureGrid />
            <InsightsSection />
            <FAQSection />
            <TestimonialSection />
        </>
    );
}
export default Home;
